var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.img)?_c('div',{staticClass:"container banner row justify-center items-center image"},[_c('v-img',{key:_vm.img.url,attrs:{"item":_vm.item,"img":_vm.img,"zoom":_vm.zoom,"isSport":_vm.isSport}})],1):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02a0363c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/front/Banner.vue
// module id = rKxE
// module chunks = 54